export type GarageVehicleOwnerFields = {
  ownerFounderBadge?: boolean;
  ownerFullName: string | null;
  ownerPhotoURL: string | null;
  ownerUsername: string | null;
  ownerVerifiedBadge?: boolean;
};

export type GarageVehicleOwnerProfile = {
  founderBadge?: boolean | null;
  fullName?: string | null;
  photoURL?: string | null;
  username?: string | null;
  verifiedBadge?: boolean | null;
};

function cleanOwnerText(value: string | null | undefined, maxLength: number) {
  return typeof value === 'string' && value.trim()
    ? value.trim().slice(0, maxLength)
    : null;
}

export function withLiveGarageVehicleOwnerProfile<
  Vehicle extends GarageVehicleOwnerFields | null,
>(
  vehicle: Vehicle,
  ownerProfile: GarageVehicleOwnerProfile | null | undefined,
): Vehicle {
  if (!vehicle || !ownerProfile) {
    return vehicle;
  }

  return {
    ...vehicle,
    ownerFounderBadge: ownerProfile.founderBadge === true,
    ownerFullName:
      cleanOwnerText(ownerProfile.fullName, 80) ?? vehicle.ownerFullName,
    ownerPhotoURL:
      cleanOwnerText(ownerProfile.photoURL, 2048) ?? vehicle.ownerPhotoURL,
    ownerUsername:
      cleanOwnerText(ownerProfile.username, 30) ?? vehicle.ownerUsername,
    ownerVerifiedBadge: ownerProfile.verifiedBadge === true,
  } as Vehicle;
}
